import { MaintenancePage } from './components/pages'

function App() {
  return (
    <div className="App">
      <MaintenancePage />
    </div>
  )
}

export default App
